<div class="confirmation-pop">
    <div class="confirmation-pop-body">
        <div class="check-section"
            [class.set-background-green]="type"
            [class.mb-2]="type">
            <span class="icon" *ngIf="!type && data?.popUpType === 'archived-beat' && data?.popUpType !== 'negotiation-alert' &&  data?.popUpType !==  'disable_mp3_download'">?</span>
            <span class="icon" *ngIf="!type && data?.popUpType !== 'archived-beat' && data?.popUpType !== 'negotiation-alert' && data?.popUpType !==  'disable_mp3_download'" [class.showError]="data?.popUpType === 'stem-error'">!</span>
            <i class="fa fa-info icon" aria-hidden="true" *ngIf="type && data?.popUpType !== 'negotiation-alert'"></i>
            <div class="img-container" *ngIf="!type && (data?.popUpType === 'negotiation-alert' || data?.popUpType ===  'disable_mp3_download')">
                <img priority src="./assets/imgs/nego_icon.png" alt="negotiation-alert-icon" width="24" height="24" *ngIf="data?.popUpType === 'negotiation-alert'">
                <img priority src="./assets/imgs/music-icon.png" alt="negotiation-alert-icon" width="24" height="24" *ngIf="data?.popUpType === 'disable_mp3_download'">
            </div>
        </div>
        <p class="sub-heading" *ngIf="!type">
            <ng-container *ngIf="!type && data?.popUpType !== 'archived-beat' && (data?.popUpType === 'confirmation-pop' || data?.popUpType === 'logout') else notHow">
                <span> <span *ngIf="data?.buttonName !== 'Go To Store Settings' &&  !data?.openType && !data?.message.includes('enrolled in the')"><span *ngIf="data?.popUpType !== 'stem-error'">Are you sure you want to</span>&nbsp;</span><span [innerHTML]="data?.message"></span></span>
            </ng-container>
            <ng-template #notHow>
                <ng-container *ngIf="data?.popUpType !== 'stem-error' && data?.popUpType !== 'negotiation-alert' && data?.popUpType !== 'disable_mp3_download' && !data?.isNegotiationOn">
                    <span class=""> Are you sure?</span>
                </ng-container>
            </ng-template>
        </p>
        <p class="sub-heading pt-1" >
            <span  *ngIf="!type && data?.popUpType !== 'archived-beat' && (data?.popUpType !== 'confirmation-pop' && data?.popUpType !== 'logout')"> <span *ngIf="data?.popUpType !== 'stem-error'">{{data?.popUpType === 'negotiation-alert' ? 'Do you wish to' : 'Do you want to'}}</span>&nbsp;<span [innerHTML]="data?.message"></span></span>
            <span  *ngIf="!type && data?.popUpType === 'archived-beat' && (data?.popUpType !== 'confirmation-pop' && data?.popUpType !== 'logout')  ">{{ data?.popUpType === 'negotiation-alert' ? 'Do you wish to' : 'Do you want to'}} <span [innerHTML]="data?.message"></span></span>
            <span  *ngIf="!type && data?.popUpType !== 'archived-beat' && data?.popUpType === 'confirmation-pop' &&
            data?.buttonName !== 'Go To Store Settings' &&  !data?.openType && data?.message !== 'accept the offer?'
            && data?.message !== 'close this negotiation?' && !data?.message.includes('reject the offer?') && !data?.message.includes('Disenroll') && !data?.message.includes('enrolled in the')">Unsaved Changes will be lost.</span>
            <span  *ngIf="type"><span [innerHTML]="data?.message"></span></span>
        </p>
        <p class="sub-heading p-0" *ngIf="data?.popUpType === 'stem-error'">
            <span class=""> Are you sure you want to submit?</span>
        </p>
        <p class="sub-heading p-0" *ngIf="data?.subMessage && data?.popUpType === 'archived-beat'">
            <span class=""> {{data?.subMessage}}</span>
        </p>
        <p class="sub-heading logout-sub-heading p-0" *ngIf="data?.subMessage && data?.popUpType === 'logout' || data?.popUpType === 'negotiation-alert' || data?.popUpType === 'disable_mp3_download'">
            <span class="sub-message-logout"> {{data?.subMessage}}</span>
        </p>
        <div class="ipm-actions" >
            <button  color="primary yes-button"
                    class="primary-button ipm-submit-btn ipm-action-button"
                    [class.show-width-100]="!(type &&   data?.popUpType === 'stem-error') &&  !(!type)"
                    type="submit"
                    (click)="close('yes')">
                    {{data?.buttonName}}
            </button>
            <button color="primary"
                    class="primary-button close-button-primary ipm-submit-btn "
                    type="submit"
                    (click)="close('cancel')"
                    *ngIf="type &&   data?.popUpType === 'stem-error' ||  data?.openType">
                    No
            </button>
            <button color="primary"
                    class="primary-button close-button-primary ipm-submit-btn "
                    type="submit"
                    (click)="close('cancel')"
                    *ngIf="!type && !data?.openType">
                    {{data?.openType}}
                    Cancel
            </button>
        </div>
    </div>
</div>
